import { render, staticRenderFns } from "./shiting.vue?vue&type=template&id=f374daea&scoped=true"
import script from "./shiting.vue?vue&type=script&lang=js"
export * from "./shiting.vue?vue&type=script&lang=js"
import style0 from "./shiting.vue?vue&type=style&index=0&id=f374daea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f374daea",
  null
  
)

export default component.exports